<!-- 我的收藏 -->
<template>
  <div class="el-Favorites">
    <el-row class="content_block mb30">
      <TitleInfo title="我的收藏" :titleImg="shouc"></TitleInfo>
      <el-row class="p20" style="min-height: 320px;overflow: auto;">
        <el-row style="text-align: right;margin-bottom: 20px;">
          <el-button type="primary" @click="seeInfo('see')">题目练习</el-button>
          <!-- <el-button type="success" @click="exportInfo">导出</el-button> -->
        </el-row>
        <el-row>
          <el-table
            :data="tableData"
            border
            style="width: 100%">
            <el-table-column type="index" header-align="center" align="center" width="100" label="序号"></el-table-column>
            <el-table-column prop="questionStem" header-align="center" align="left" label="题干">
              <template slot-scope="scope">
                <el-row v-html="$getReplace(scope.row.questionStem)"></el-row>
              </template>
            </el-table-column>
            <el-table-column prop="questionType" header-align="center" align="center" label="题型" width="100">
              <template slot-scope="scope">
                {{$retQuestionType(scope.row.questionType)}}
              </template>
            </el-table-column>
            <el-table-column prop="questionAnswer" header-align="center" align="center" label="正确答案" width="180">
              <template slot-scope="scope">
                <div v-html="$retAnswer(scope.row.questionAnswer,scope.row.questionType)"></div>
              </template>
            </el-table-column>
            <el-table-column prop="messageAcceptState" header-align="center" align="center" label="操作" width="180">
              <template slot-scope="scope">
                <el-link type="primary" class="mr20" :underline="false" @click="seeInfo(scope.row,scope.$index)">查看</el-link>
                <el-link type="primary" :underline="false" @click="delInfo(scope.row)">移出</el-link>
              </template>
            </el-table-column>
          </el-table>
          <div class="block" style="text-align: right;bottom: 0;width: 96%;margin: 20px;">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="page"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="limit"
              background
              :hide-on-single-page="true"
              layout="sizes, prev, pager, next,jumper"
              :total="total">
            </el-pagination>
          </div>
        </el-row>
      </el-row>
    </el-row>

    <el-dialog
      title="题目详情1"
      class="right_CoachErrorSet"
      :visible.sync="dialogVisible"
      width="800">
      <div style="height: 400px;overflow: auto;">
        <el-col :span="21">
          <el-row style="float: left;width: 30px;">
            {{((page - 1) * limit) + (onIndex + 1)}}、
          </el-row>{{onInfo.generalQuestionLogId}}
          <el-row style="float: left;width: calc(100% - 30px);line-height: 20px;margin-bottom: 10px;">
            <!-- <el-row class="questionStemClass" v-html="onInfo.questionStem"></el-row> -->
            <previewIndex :key="onInfo.teacherOpenCourseQuestionLogId" :editorId="onInfo.teacherOpenCourseQuestionLogId+'_stem'" styleInfo="border:none;padding:0;" v-if="!$isEmpty(onInfo.questionStem)" :modelValue="onInfo.questionStem"></previewIndex>
          </el-row>
          <ul style="width: 100%;margin-left: 30px;">
            <template v-if="onInfo.questionType == 1">
              <el-radio-group :disabled="!$isEmpty(onInfo.teacherOpenCourseQuestionLogAnswer)" v-model="onInfo.questionAnswer">
                <li v-if="!$isEmpty(onInfo.questionOptionA)">
                  <el-radio label="A">
                    <el-row class="optionInfo">A、</el-row>
                    <el-row class="xuanxiang" v-html="$imgHtml(onInfo.questionOptionA)"></el-row>
                  </el-radio>
                </li>
                <li v-if="!$isEmpty(onInfo.questionOptionB)">
                  <el-radio label="B">
                    <el-row class="optionInfo">B、</el-row>
                    <el-row class="xuanxiang" v-html="$imgHtml(onInfo.questionOptionB)"></el-row>
                  </el-radio>
                </li>
                <li v-if="!$isEmpty(onInfo.questionOptionC)">
                  <el-radio label="C">
                    <el-row class="optionInfo">C、</el-row>
                    <el-row class="xuanxiang" v-html="$imgHtml(onInfo.questionOptionC)"></el-row>
                  </el-radio>
                </li>
                <li v-if="!$isEmpty(onInfo.questionOptionD)">
                  <el-radio label="D">
                    <el-row class="optionInfo">D、</el-row>
                    <el-row class="xuanxiang" v-html="$imgHtml(onInfo.questionOptionD)"></el-row>
                  </el-radio>
                </li>
                <li v-if="!$isEmpty(onInfo.questionOptionE)">
                  <el-radio label="E">
                    <el-row class="optionInfo">E、</el-row>
                    <el-row class="xuanxiang" v-html="$imgHtml(onInfo.questionOptionE)"></el-row>
                  </el-radio>
                </li>
              </el-radio-group>
            </template>
            <template v-if="onInfo.questionType == 2">
              <el-checkbox-group :disabled="!$isEmpty(onInfo.teacherOpenCourseQuestionLogAnswer)" v-model="onInfo.questionAnswer.split(',')">
                <li v-if="!$isEmpty(onInfo.questionOptionA)">
                  <el-checkbox label="A">
                    <el-row class="optionInfo">A、</el-row>
                    <el-row class="xuanxiang" v-html="$imgHtml(onInfo.questionOptionA)"></el-row>
                  </el-checkbox>
                </li>
                <li v-if="!$isEmpty(onInfo.questionOptionB)">
                  <el-checkbox label="B">
                    <el-row class="optionInfo">B、</el-row>
                    <el-row class="xuanxiang" v-html="$imgHtml(onInfo.questionOptionB)"></el-row>
                  </el-checkbox>
                </li>
                <li v-if="!$isEmpty(onInfo.questionOptionC)">
                  <el-checkbox label="C">
                    <el-row class="optionInfo">C、</el-row>
                    <el-row class="xuanxiang" v-html="$imgHtml(onInfo.questionOptionC)"></el-row>
                  </el-checkbox>
                </li>
                <li v-if="!$isEmpty(onInfo.questionOptionD)">
                  <el-checkbox label="D">
                    <el-row class="optionInfo">D、</el-row>
                    <el-row class="xuanxiang" v-html="$imgHtml(onInfo.questionOptionD)"></el-row>
                  </el-checkbox>
                </li>
                <li v-if="!$isEmpty(onInfo.questionOptionE)">
                  <el-checkbox label="E">
                    <el-row class="optionInfo">E、</el-row>
                    <el-row class="xuanxiang" v-html="$imgHtml(onInfo.questionOptionE)"></el-row>
                  </el-checkbox>
                </li>
              </el-checkbox-group>
            </template>
            <template v-if="onInfo.questionType == 3">
              <el-radio-group :disabled="!$isEmpty(onInfo.teacherOpenCourseQuestionLogAnswer)" v-model="onInfo.questionAnswer">
                <li>
                  <el-radio label="对">
                    <el-row class="xuanxiang">对</el-row>
                  </el-radio>
                </li>
                <li>
                  <el-radio label="错">
                      <el-row class="xuanxiang">错</el-row>
                  </el-radio>
                </li>
              </el-radio-group>
            </template>
          </ul>
          <template v-if="onInfo.questionType == 4">
            <!-- <template v-for="i in Number(onInfo.questionOptionA)">
              <el-input
                type="textarea"
                @change="seeQuestion(onInfo,i)"
                :autosize="{ minRows: 2, maxRows: 4}"
                placeholder="请输入内容"
                :style="Number(onInfo.questionOptionA) > 1 && i != Number(onInfo.questionOptionA)?'margin-bottom: 10px;':''"
                v-model="completion[onInfo.generalQuestionLogId][i]">
              </el-input>
            </template> -->
          </template>
          <template v-if="onInfo.questionType == 5">
            <el-row class="questionStemClass" style="margin-bottom: 10px;">
              <previewIndex :editorId="onInfo.teacherOpenCourseQuestionLogId" :key="onInfo.teacherOpenCourseQuestionLogId" v-if="!$isEmpty(onInfo.questionOptionB)" styleInfo="border:none;padding:0px 20px;" :modelValue="onInfo.questionOptionB"></previewIndex>
            </el-row>
            <!-- <template v-for="i in Number(onInfo.questionOptionA)">
              <el-input
                type="textarea"
                @change="seeQuestion(onInfo,i)"
                :autosize="{ minRows: 2, maxRows: 4}"
                placeholder="请输入内容"
                :style="Number(onInfo.questionOptionA) > 1 && i != Number(onInfo.questionOptionA)?'margin-bottom: 10px;':''"
                v-model="analyticQuestion[onInfo.generalQuestionLogId][i]">
              </el-input>
            </template> -->
          </template>
          <template v-if="!$isEmpty(onInfo.teacherOpenCourseQuestionLogAnswer)">
            <el-row style="line-height: 30px;">
              <el-row v-if="onInfo.questionType != 4 && onInfo.questionType != 5" style="display: flex;align-items: center;">
                <i class="el-icon-circle-check" style="color: #5464FF;font-size: 40px;" v-if="onInfo.teacherOpenCourseQuestionLogAnswer == onInfo.questionAnswer"></i>
                <i class="el-icon-circle-close" style="color: red;font-size: 40px;" v-else ></i>
                <span style="margin-left: 10px;">正确答案：{{onInfo.questionAnswer}}</span>
                <span style="margin-left: 10px;">我的答案：{{onInfo.teacherOpenCourseQuestionLogAnswer}}</span>
              </el-row>
              <el-row v-if="onInfo.questionType == 4 || onInfo.questionType == 5">
                <!-- <el-col :span="2">
                  <i class="el-icon-circle-check" style="color: #5464FF;font-size: 40px;" v-if="onInfo.teacherOpenCourseQuestionLogAnswer == onInfo.questionAnswer"></i>
                  <i class="el-icon-circle-close" style="color: red;font-size: 40px;" v-else ></i>
                </el-col> -->
                <el-col :span="10">
                  <el-row style="width: 100%;" v-for="(ite,inde) in JSON.parse(onInfo.questionAnswer)" :key="inde+onInfo.generalQuestionLogId">
                    <p class="mt5 mb5"><span style="color: rgb(84, 100, 255);">{{$chineseNum(inde - 1,1)}}:</span>{{ite}}</p>
                  </el-row>
                </el-col>
              </el-row>
              <p>解析：{{onInfo.questionAnalysis || '-'}}</p>
            </el-row>
          </template>
        </el-col>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import TitleInfo from "@/components/TitleInfo";	//页面头部
import previewIndex from "@/components/editorMd/previewIndex";	//富文本editorMd
export default {
  name: "CourseFavorites",
  components: {
  	TitleInfo,
    previewIndex
  },
  data() {
    return {
      shouc:require("../../images/course/shouc@2x.png"),
      teacherOpenCourseId:this.$route.query.courseId,
      teacherOpenCourseQuestionSettingId:this.$route.query.id,
      tableData:[],
      total: 0,
      limit:10,
      page:1,
      dialogVisible:false,
      onInfo:{}, //当前查看题目信息
      onIndex:0
    };
  },
  created() {
    this.getInfo();
  },
  mounted() {

  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.limit = val;
      this.getInfo();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.page = val;
      this.getInfo();
    },
    getInfo(){ //获取列表
      let param = {
        limit:this.limit,
        page:this.page,
        teacherOpenCourseId:this.teacherOpenCourseId,
        teacherOpenCourseQuestionSettingId:this.teacherOpenCourseQuestionSettingId,
        questionSettingIds:this.teacherOpenCourseQuestionSettingId,
      }
      this.$get("/api/teacherOpenCourseQuestionLog/tuckList.do",param).then((ret) =>{
        if(ret.code == 0){
          this.total = Number(ret.count);
          this.tableData = ret.data;
        }else{
          this.$message({message: ret.msg,type: 'error'});
        }
      });
    },
    exportInfo(){ //导出错题
      let param = "teacherOpenCourseQuestionSettingId="+this.teacherOpenCourseQuestionSettingId;
      window.open(this.$baseUrl + "/jlw/teacherOpenCourseQuestionLogWrong/excel/export.json?"+param);
    },
    seeInfo(item,index){ //查看
      if(item != "see"){
        this.onInfo = item;
        this.dialogVisible = true;
        this.onIndex = index;
      }else{
        this.$router.push({name:'PracticeErrorTuckExercise',query:{teacherOpenCourseQuestionSettingId:this.teacherOpenCourseQuestionSettingId,tuckOrError:"TUCK_TEST"}});
        }
    },
    delInfo(item){ //移出
      this.$post("/api/teacherOpenCourseQuestionLog/tuckByLogIds.do",{teacherOpenCourseQuestionLogIds:item.teacherOpenCourseQuestionLogId, isTuck: false}).then((ret) =>{
        if(ret.code == 0){
          this.getInfo();
          this.$message.success('移出成功!');
        }else{
          this.$message({message: ret.msg,type: 'error'});
        }
      });
    }
  }
};
</script>
 <style  lang="less">
  .el-Favorites{
    padding: 20px 20px 0;
    .content_block{
      background-color: #ffffff;
    }

    .right_CoachErrorSet{
      padding: 20px;
      ul{
        padding: 10px 0;
      }
      li{
        line-height: 20px;
      }
      .el-radio__input.is-disabled+span.el-radio__label,.el-checkbox__input.is-disabled+span.el-checkbox__label{
        color: #424344;
      }
    }
  }
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->



// WEBPACK FOOTER //
// src/pages/course/Favorites.vue